import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import FopListItem from './FopListItem';
import FopImpressionsContainer from 'apps/gtm/components/FopImpressionsContainer';
import SortOption from 'apps/catalogue/models/SortOption';
import { SORT_OPTION_TO_NAME_MAPPING } from 'apps/catalogue/components/SortSelect';

export default class FopList extends PureComponent {
  static propTypes = {
    fopElementsFactory: PropTypes.shape({
      getFopTypeClass: PropTypes.func,
      calculateClassNames: PropTypes.func,
    }).isRequired,
    fopType: PropTypes.string,
    forwardedRef: PropTypes.func,
    gtmPageType: PropTypes.string,
    maxDisplayFops: PropTypes.number, // by default display all FOPs
    totalFops: PropTypes.number.isRequired,
    productsBySku: PropTypes.object.isRequired,
    productsPageRoute: PropTypes.object.isRequired,
    registerFopRef: PropTypes.func,
    pageParameters: PropTypes.object,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        fops: PropTypes.arrayOf(
          PropTypes.shape({
            sku: PropTypes.string.isRequired,
            hash: PropTypes.number,
          })
        ),
        contentBeforeFops: PropTypes.node,
        contentAfterFops: PropTypes.node,
      })
    ).isRequired,
    sectionRibbonDisplayed: PropTypes.bool, // by default ribbons are not displayed
    skipAnalytics: PropTypes.bool,
    useSectionTitleAsListName: PropTypes.bool,
  };

  static childContextTypes = {
    gtmPageType: PropTypes.string,
    gtmNumberOfResults: PropTypes.number,
    gtmSortBy: PropTypes.string,
    gtmFilterValues: PropTypes.string,
  };

  getChildContext() {
    const filterValues = get(this.props, 'pageParameters.filters', [])
      .map(
        item => `${item.filterType}: ${item.name}`
      )
      .join(' | ');

    return {
      gtmPageType: this.props.gtmPageType || 'NA',
      gtmNumberOfResults: this.props.totalFops,
      gtmSortBy: SORT_OPTION_TO_NAME_MAPPING[get(this.props, 'pageParameters.sort', SortOption.DEFAULT)],
      gtmFilterValues: filterValues,
    };
  }

  generateFirstNFops({ numberFopsToGenerate, section, sectionIdx, numberOfPrecedingFops }) {
    const {
      fopElementsFactory,
      fopType,
      productsBySku,
      productsPageRoute,
      registerFopRef,
      sectionRibbonDisplayed = false,
      pageParameters,
    } = this.props;

    const fopInSection = [];
    for (let sectionFopIdx = 0; sectionFopIdx < numberFopsToGenerate; ++sectionFopIdx) {
      const fop = section.fops[sectionFopIdx];
      const { sku, hash } = fop;
      const product = productsBySku[sku];
      fopInSection.push(
        <FopListItem
          // React stuff
          key={`${section.id}_${sku}`}
          // FOP data
          product={product}
          fop={fop}
          // Ribbon data
          section={section}
          collectionFopIdx={numberOfPrecedingFops + sectionFopIdx}
          sectionFopIdx={sectionFopIdx}
          sectionIdx={sectionIdx}
          fopType={fopType}
          productsPageRoute={productsPageRoute}
          sectionRibbonDisplayed={sectionRibbonDisplayed}
          // Scroll Watcher data
          sku={sku}
          hash={hash}
          registerRef={registerFopRef}

          pageParameters={pageParameters}
          fopElementsFactory={fopElementsFactory}
          className={fopElementsFactory.calculateClassNames(sku)}
        />
      );
    }
    return fopInSection;
  }

  generateContent() {
    const { sections, maxDisplayFops = Number.MAX_SAFE_INTEGER } = this.props;
    let content = [];
    let fopNo = 0;

    for (let sectionId = 0; sectionId < sections.length && fopNo < maxDisplayFops; ++sectionId) {
      const section = sections[sectionId];
      let fopInSection = [];

      if (section.fops) {
        const numberFopsToGenerate = Math.min(maxDisplayFops - fopNo, section.fops.length);

        fopInSection = this.generateFirstNFops({
          numberFopsToGenerate,
          section,
          sectionIdx: sectionId,
          numberOfPrecedingFops: fopNo,
        });
        fopNo += fopInSection.length;
      }

      if (section.contentBeforeFops) content.push(section.contentBeforeFops);

      if (section.fops) {
        content = content.concat(fopInSection);
      }

      if (section.contentAfterFops) content.push(section.contentAfterFops);
    }

    return content;
  }

  render() {
    const {
      fopElementsFactory,
      forwardedRef,
      useSectionTitleAsListName,
      skipAnalytics,
    } = this.props;

    const generatedContent = this.generateContent();

    if (!generatedContent.length) {
      return null;
    }

    return (
      <FopImpressionsContainer skipAnalytics={skipAnalytics} useSectionTitleAsListName={useSectionTitleAsListName}>
        <ul className={`fops ${fopElementsFactory.getFopTypeClass()}`} ref={forwardedRef}>
          {generatedContent}
        </ul>
      </FopImpressionsContainer>
    );
  }
}
